import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatPrice } from '@/utils/index'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { parseISO } from 'date-fns'
import { CHG_ACCT_MCH_UUID, CHG_ACCT_MCH_ISUPLD } from '../../../store/types'

export const matchAjaxMixin = {
  data() {
    return {
      actionName: ''
    }
  },
  methods: {
    async performSearchMchDet() {
      const apiUrl = this.$store.state.commons.menu.acctMchDetList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const paramMap = {
            page: page - 1,
            size: itemsPerPage
          }
          if (this.matchForm.matchedDateDisp !== '') {
            this.matchForm.matchedDate = formatDisplayDate(this.matchForm.matchedDateDisp)
          }
          let massageFilters = clone(this.matchForm)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, paramMap), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map(result => {
              const resultList = {
                mdJrnl: result.mdContJrnlNo,
                mdAcctNo: result.mdContAcctNo,
                mdBranch: result.mdContBrn,
                mdType: result.mdContTranType,
                mdDocNo: result.mdContDocNo,
                mdFund: result.mdContFund,
                mdSuffix: result.mdContAcctNoSfx,
                matchedOn: this.formatDate(result.mdDate),
                matched: formatPrice(result.mdAmt),
                mdProgId: result.mdMchProg
              }
              this.items.push(resultList)
            })
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    async performSearch() {
      const apiUrl = this.$store.state.matching.performMatch.menu.performSearch
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const paramMap = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.matchForm)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, paramMap), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map(result => {
              const resultList = {
                branch: result.branch,
                type: result.type + ' ' + result.tranType2,
                docNo: result.docNo,
                acctNo: result.acctNo,
                fund: result.fund,
                suffix: result.suffix,
                tranDate: this.formatDate(result.tranDate),
                curr: result.curr,
                netAmt: formatPrice(result.netAmount),
                osBal: formatPrice(result.osBalance),
                acctYr: result.acctYr,
                acctMth: result.acctMth
              }
              this.items.push(resultList)
              this.loading = false
            })
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    performReviewGetApiUrl() {
      let apiUrl = ''
      if (this.isUpload === true) {
        apiUrl = this.$store.state.matching.performMatch.menu.performActionBM
      } else {
        apiUrl = this.$store.state.matching.performMatch.menu.performAction
      }
      return apiUrl
    },
    async performReview() {
      let apiUrl = this.performReviewGetApiUrl()
      if (apiUrl) {
        try {
          this.matchForm.actionName = 'MATCH_REVIEW'
          this.matchForm.branch = this.matchData.branch
          this.matchForm.accountNo = this.matchData.accountNo
          this.matchForm.transactionType = this.matchData.type
          this.matchForm.documentNo = this.matchData.documentNo
          this.matchForm.fund = this.matchData.fund
          this.matchForm.suffix = this.matchData.suffix
          const response = await this.$http.post(apiUrl, this.matchForm)
          const { data } = response.data
          if (data) {
            this.matchForm.branch = data.accounts.branch
            this.matchForm.transactionType = data.accounts.transactionType
            this.matchForm.documentNo = data.accounts.documentNo
            this.matchForm.transactionDate = data.accounts.transactionDate
            this.matchForm.accountingMonth = data.accounts.accountingMonth
            this.matchForm.accountingYear = data.accounts.accountingYear
            this.matchForm.accountNo = data.accounts.accountNo
            this.matchForm.fund = data.accounts.fund
            this.matchForm.suffix = data.accounts.suffix
            this.matchForm.gstIO = data.accounts.gstIO
            if (this.matchForm.gstIO === 'I') {
              this.matchForm.gstIODesc = 'I-Input'
            } else if (this.matchForm.gstIO === 'O') {
              this.matchForm.gstIODesc = 'O-Output'
            } else if (this.matchForm.gstIO === 'B' || this.matchForm.gstIO === '') {
              this.matchForm.gstIODesc = ''
            }
            this.matchForm.gstIO = data.accounts.gstIO
            this.matchForm.gstStat = data.accounts.gstStat
            this.matchForm.gstStatDesc = data.accounts.gstStatDesc
            this.matchForm.gstRate = data.accounts.gstRate
            this.matchForm.netAmtCurr = data.accounts.netAmtCurr
            this.matchForm.netAmtCurrDesc = data.accounts.netAmtCurrDesc
            this.matchForm.netAmt = data.accounts.netAmt
            this.matchForm.netAmtLoc = data.accounts.netAmtLoc
            this.matchForm.balOS = data.accounts.balOS
            this.matchForm.balOSLoc = data.accounts.balOSLoc
            this.matchForm.matchOn = data.accounts.matchOn
            this.matchForm.totalMatchAmountCurr = data.accounts.totalMatchAmountCurr
            this.matchForm.totalMatchAmountCurrDesc = data.accounts.totalMatchAmountCurrDesc
            this.matchForm.totalMatchAmount = data.accounts.totalMatchAmount
            this.matchForm.totalMatchAmountLocal = data.accounts.totalMatchAmountLocal
            this.matchForm.baseMatchAmount = data.accounts.baseMatchAmount
            this.matchForm.balanceOutStanding = data.accounts.balanceOutStanding
            this.matchForm.balanceOutStandingLocal = data.accounts.balanceOutStandingLocal
            this.matchForm.netAmtLocAE = data.accounts.netAmtLocAE === 'true'
            this.matchForm.baseMatchAmountCurr = data.accounts.netAmtCurr
            this.matchForm.baseMatchAmountCurrDesc = data.accounts.netAmtCurrDesc
            this.matchForm.baseMatchAmountLocalCurr = data.accounts.netAmtCurr
            this.matchForm.baseMatchAmountLocalCurrDesc = data.accounts.baseMatchAmountLocalCurrDesc
            this.matchForm.balanceOutStandingCurr = data.accounts.netAmtCurr
            this.matchForm.balanceOutStandingCurrDesc = data.accounts.netAmtCurrDesc
            this.matchForm.matchedRecTransDate = new Date()
            this.matchForm.matchTransMinDate = this.parseDateISO(this.tDateRange.effDate)
            this.matchForm.matchTransMaxDate = this.parseDateISO(this.tDateRange.expDate)
            this.matchForm.branchDesc = data.accounts.branchDesc
            this.matchForm.accountNoDesc = data.accounts.accountNoDesc
            this.matchForm.fundDesc = data.accounts.fundDesc
            this.matchForm.suffixDesc = data.accounts.suffixDesc
            this.matchForm.transactionTypeDesc = data.accounts.transactionTypeDesc
          }
          return true
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async commonValidate(dataValue) {
      const apiUrl = this.$store.state.matching.performMatch.menu.commonValidate
      if (apiUrl) {
        try {
          const params = {
            accountNo: dataValue.accountNo,
            policyNo: dataValue.policyNo,
            tranType: dataValue.tranType,
            documentNo: dataValue.documentNo
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            this.notify(data)
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    getMatchDataListGetApiUrl() {
      let apiUrl = null
      if (this.selectFromMatch) {
        this.promptUpload = false
        apiUrl = this.$store.state.matching.performMatch.menu.tranToMatchUploadList
      } else {
        apiUrl = this.$store.state.matching.performMatch.menu.tranToMatchList
      }
      return apiUrl
    },
    getMatchDataListFilters() {
      let massageFilters = clone(this.filtersTransToMatch)
      if (massageFilters.transactionDateFrom !== null && massageFilters.transactionDateFrom !== '') {
        massageFilters.transactionDateFrom = formatDisplayDate(removeTime(massageFilters.transactionDateFrom))
      }
      if (massageFilters.transactionDateTo !== null && massageFilters.transactionDateTo !== '') {
        massageFilters.transactionDateTo = formatDisplayDate(removeTime(massageFilters.transactionDateTo))
      }
      if (this.UUID !== null) {
        massageFilters.uuid = this.UUID
      }
      if (this.matchFileName !== null || this.matchFileName !== undefined || this.matchFileName !== '') {
        massageFilters.fileName = this.matchFileName
      }
      massageFilters.matchedRecTransDate = formatDisplayDate(removeTime(this.matchDataEdit.matchedRecTransDate))
      return massageFilters
    },
    getMatchDataListSetList(result) {
      if (result.data) {
        this.transToMatchItems = []
        this.totalItemsMatch = result.data.totalElements
        const { data } = result.data
        if (data) {
          data.map(result => {
            let branch = result.branch === undefined ? '-' : result.branch
            let tranType = result.tranType === undefined ? '-' : result.tranType
            let docNo = result.docNo === undefined ? '-' : result.docNo
            let acctNo = result.acctNo === undefined ? '-' : result.acctNo
            let fund = result.fund === undefined ? '-' : result.fund
            let acctNoSfx = result.acctNoSfx === undefined ? '-' : result.acctNoSfx
            const resultList = {
              key: branch + tranType + docNo + acctNo + fund + acctNoSfx,
              tranDate: this.formatDate(result.tranDate),
              polNo: result.policyNo,
              acctNo: result.acctNo,
              branch: result.branch,
              type: result.type + ' ' + result.tranType2,
              docNo: result.docNo,
              fund: result.fund,
              suffix: result.suffix,
              curr: result.curr,
              netAmt: formatPrice(result.netAmount),
              osBal: formatPrice(result.osBalance),
              locOsBal: formatPrice(result.locOsBal),
              tranType: result.type,
              comm: formatPrice(result.commission),
              matchAmt: formatPrice(result.osBalance),
              originalLocOsBal: formatPrice(result.locOsBal),
              currRate: result.currRate
            }
            this.transToMatchItems.push(resultList)
          })
          if (this.selectFromMatch && this.matchSelected.length === 0) {
            this.matchSelected = [...this.transToMatchItems]
          }
        } else {
          this.transToMatchItems = []
        }
      }
    },
    async getMatchDataList() {
      let apiUrl = this.getMatchDataListGetApiUrl()
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationMatch
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            mBranch: this.matchData.branch,
            mFund: this.matchData.fund,
            mSuffix: this.matchData.suffix,
            mAcctMth: this.matchData.acctMth,
            mAcctYr: this.matchData.acctYr,
            mCurr: this.matchData.curr,
            mDocNo: this.matchData.documentNo,
            mAcctNo: this.matchData.accountNo,
            mTranType: this.matchData.type
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), this.getMatchDataListFilters(), this.paginationMatch.sortBy, this.paginationMatch.sortDesc)
          )
          this.getMatchDataListSetList(result)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async performSave() {
      let apiURI = ''
      if (this.isUpload === true) {
        apiURI = this.$store.state.matching.performMatch.menu.performActionBM
      } else {
        apiURI = this.$store.state.matching.performMatch.menu.performAction
      }
      if (apiURI) {
        try {
          let messageFilters = clone(this.matchForm)
          if (messageFilters.matchedRecTransDate !== '') {
            messageFilters.matchedRecTransDate = formatDisplayDate(this.matchForm.matchedRecTransDate)
          }
          const result = await this.$http.post(apiURI, messageFilters)

          const { data } = result
          if (data) {
            this.processingFlag = false
            this.notify(data)
            this.unlockRecord(this.$store.state.accounts.acctMchObj.baseRecKey, 'ACT')
            this.doExit()
          }
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async calculateSelectedData(list, matchRecTranDate, matchOn, balOS, netAmtCurr) {
      const apiUrl = this.$store.state.matching.performMatch.menu.calculateSelectedData
      if (apiUrl) {
        try {
          const expand = {
            selectedMatchList: list,
            matchRecTranDate: matchRecTranDate,
            matchOn: matchOn,
            baseOSBal: balOS,
            baseCurr: netAmtCurr
          }
          const result = await this.$http.post(apiUrl, expand)
          if (result.data) {
            this.rsSelectedMatchDetItems = []
            const { data } = result.data
            if (data) {
              data.map(result => {
                const resultList = {
                  tranDate: result.tranDate,
                  polNo: result.polNo,
                  acctNo: result.acctNo,
                  branch: result.branch,
                  type: result.type,
                  docNo: result.docNo,
                  fund: result.fund,
                  suffix: result.suffix,
                  curr: result.curr,
                  netAmt: result.netAmt,
                  rsMatchAmt: formatPrice(result.rsMatchAmt),
                  rsOsBal: formatPrice(result.rsOsBal),
                  rsLocOSBal: formatPrice(result.rsLocOSBal),
                  osBal: result.osBal,
                  locOsBal: result.locOsBal,
                  tranType: result.tranType,
                  comm: result.comm,
                  detail: 'Detail',
                  originalLocOsBal: result.originalLocOsBal,
                  isEditMatchAmt: result.isEditMatchAmt,
                  tranType2: result.tranType2,
                  currRate: result.currRate
                }
                this.matchForm.matchDetItems.push(resultList)
              })
            }
            return true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async calculateBaseAmountData() {
      const apiUrl = this.$store.state.matching.performMatch.menu.calculateBaseAmountData
      this.calculLoading = true
      if (apiUrl) {
        try {
          let massageFilters = clone(this.matchForm)

          if (this.matchForm.matchedRecTransDate !== '') {
            massageFilters.matchedRecTransDate = formatDisplayDate(removeTime(this.matchForm.matchedRecTransDate))
          }
          const result = await this.$http.post(apiUrl, massageFilters)
          const { data } = result.data
          let message
          if (data) {
            this.matchForm.totalMatchAmount = formatPrice(data.accounts.totalMatchAmount)
            this.matchForm.totalMatchAmountLocal = formatPrice(data.accounts.totalMatchAmountLocal)
            this.matchForm.baseMatchAmount = formatPrice(data.accounts.baseMatchAmount)
            this.matchForm.baseMatchAmountLocal = formatPrice(data.accounts.baseMatchAmountLocal)
            this.matchForm.balanceOutStanding = formatPrice(data.accounts.balanceOutStanding)
            this.matchForm.balanceOutStandingLocal = formatPrice(data.accounts.balanceOutStandingLocal)
            this.matchForm.totalMatchAmountCurr = data.accounts.totalMatchAmountCurr
            this.matchForm.totalMatchAmountLocalCurr = data.accounts.companyCurr
            this.matchForm.baseMatchAmountCurr = data.accounts.baseCurr
            this.matchForm.baseMatchAmountLocalCurr = data.accounts.companyCurr
            this.matchForm.balanceOutStandingCurr = data.accounts.baseCurr
            this.matchForm.totalMatchAmountCurrDesc = data.accounts.totalMatchAmountCurrDesc
            this.matchForm.totalMatchAmountLocalCurrDesc = data.accounts.companyBaseCurrencyDesc
            this.matchForm.baseMatchAmountCurrDesc = data.accounts.baseCurrencyDesc
            this.matchForm.baseMatchAmountLocalCurrDesc = data.accounts.companyBaseCurrencyDesc
            this.matchForm.balanceOutStandingCurrDesc = data.accounts.baseCurrencyDesc
            message = data.msg
          }
          this.calculLoading = false
          if (message !== '') {
            const errMsg = {
              messages: [{ message: message, type: 'ERROR' }]
            }
            this.message(errMsg)
            this.fieldMessage(errMsg)
          }
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    doExit() {
      if (this.matchData.frmModule !== undefined && this.matchData.frmModule !== '') {
        if (this.matchData.printDoc === 'I') {
          let massageFilters = clone(this.matchData)
          massageFilters.actionName = this.matchForm.actionName
          if (this.matchData.type === 'Z') {
            this.doExportAcctPaytDoc(massageFilters)
          } else if (massageFilters.type === 'Y') {
            this.doExportAcctDoc(massageFilters)
          } else if (massageFilters.type === 'B') {
            this.doExportAcctCrNoteDoc(massageFilters)
          } else if (massageFilters.type === 'A') {
            this.doExportAcctDrNoteDoc(massageFilters)
          }
        }
        this.$router.push({ name: 'accounts' })
      } else {
        if (this.isUpload === true) {
          this.$router.push({ name: 'matchTransactionUpload' })
        } else {
          this.$router.push({ name: 'matchTransaction' })
        }
        this.$store.commit(CHG_ACCT_MCH_ISUPLD, false)
      }
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    async doUpload() {
      sessionStorage.removeItem('matchList')
      this.$store.commit(CHG_ACCT_MCH_UUID, null)
      const apiUrl = this.$store.state.matching.performMatch.menu.uploadTranToMatchList
      if (apiUrl) {
        try {
          this.processingFlag = true
          let formData = new FormData()
          formData.append('file', this.file)
          formData.append('acctNo', this.matchForm.accountNo)
          const result = await this.$http.post(apiUrl, formData)
          if (result.data) {
            const { data } = result.data
            this.$store.commit(CHG_ACCT_MCH_UUID, data.results)
            this.$toast.success('File upload successfully!')
            this.form.requestedFile = ''
          }
          this.processingFlag = false
          this.promptUpload = false
          this.showSelectTransToMatch = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.form.requestedFile = ''
          this.promptUpload = false
          this.processingFlag = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [uploadSanctionList]')
      }
    }
  },
  computed: {
    matchDataEdit() {
      return this.$store.state.matching.matchDataEdit
    },
    UUID() {
      return this.$store.state.accounts.acctMchObj.UUID
    },
    isUpload() {
      return this.$store.state.accounts.acctMchObj.isUpload
    }
  }
}
